import React from 'react';
import { FormattedMessage } from 'react-intl';

type FormIntroProps = {
  message: string;
};

const FormIntro: React.FC<FormIntroProps> = ({ message }: FormIntroProps) => {
  return (
      <div className="inline form-intro-text">
        { <FormattedMessage id={message} /> }
      </div>
  );
};

export default FormIntro;
